// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/technical-record-schedule-ii-timing.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/technical-record-schedule-ii-timing/technical-record-schedule-ii-timing.js';

mount([g0]);
